import { validateEmail } from "@/utils/validate-email";

const MANDATORY_FIELD_ERROR = "Mandatory field";

export default (formData) => {
  const validators = {
    email: (email) => {
      if (!validateEmail(email)) return "Invalid email";
    },
  };

  return Array.from(formData.keys()).reduce((errors, key) => {
    if (!formData.get(key)) {
      return { ...errors, [key]: MANDATORY_FIELD_ERROR };
    }

    if (validators[key]) {
      const error = validators[key](formData.get(key));
      if (error) {
        return { ...errors, [key]: error };
      }
    }
    return errors;
  }, {});
};
